<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
// import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Production Batches",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Production Batches",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Production Batches",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id:'',
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "batch_id",
          sortable: true,
          label: "ID",
        },
        {
          key: "maize_quantity",
          sortable: true,
          label: "MAIZE QTY",
        },
        {
          key: "maize_price",
          sortable: true,
          label: "MAIZE PRICE",
        },
        {
          key: "total_cost",
          sortable: true,
          label: "TOTAL COST",
        },
        {
          key: "total_brand",
          sortable: true,
          label: "BRAND",
        },
        {
          key: "cost_price",
          sortable: true,
          label: "UNIT COSTPRICE",
        },
        {
          key: "brand_sellingprice",
          sortable: true,
          label: "BRAND PRICE",
        },
        {
          key: "brand%ge",
          sortable: true,
          label: "BRAND %ge",
        },
        {
          key: "product%ge",
          sortable: true,
          label: "PRODUCT %ge",
        },
        {
          key: "loss",
          sortable: true,
          label: "LOSS %ge",
        },        
        {
          key: "total_labour",
          sortable: true,
          label: "LABOUR",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTION",
        }
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      },
      deleteData: {
          id: "",
      },
      editData: {
          id: "",
      },
      totals: {
        totalAmount: 0,
        totalBrand: 0,
        totalMaizeQty: 0,
      },
      filterTitle: "",
      filteredReport: [],
      json_fields: {
        TOTAL_COST: "total",
        TOTAL_BRAND: "total_brand",
        UNIT_COSTPRICE: "cost_price",
        BRAND_PRICE: "brand_sellingprice",
        MADE_BY: "user",
        DATE: "date"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("production", ["ProductionBatches", "filterStatus", "SaveStatus"]),
    ...mapGetters("auth", ["business","branch","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapState("notification", ["type", "message", "show"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionBatches ? this.ProductionBatches.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductionBatches ? this.ProductionBatches.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProductionBatches: "production/fetchProductionBatches",
      EditBatch: "production/editBatch",
      DeleteBatch: "production/deleteBatch",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    filterReport(){
      this.FetchProductionBatches(this.data);
    },

    Viewdetails(id){
      if(id){
        this.$router.push(`/production/batch_details/${btoa(id)}`);
      }
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
    },
    resetDelete(){
      this.deleteData.id = "";
    },
    resetEdit(){
      this.editData.id = "";
    },
    editBatch(modalId){
        this.modal_id = modalId;
        this.EditBatch(this.editData);
    },
    deleteBatch(modalId){
        this.modal_id = modalId;
        this.DeleteBatch(this.deleteData);
    },
    closeModal(modalId) {
      this.resetDelete();
      this.resetEdit();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },

  updated(){
    let total_amount = 0;
    let total_brand = 0;
    let total_maizeqty = 0;
    // let total_paid = 0;
    if(this.ProductionBatches){
      this.ProductionBatches.forEach((item)=>{
        total_amount = total_amount+parseInt(item.total_cost);
        total_brand = total_brand+parseInt(item.total_brand);
        total_maizeqty = total_maizeqty+parseInt(item.maize_quantity.replaceAll(/,/g, ''));
      });
      this.totals.totalAmount = total_amount;            
      this.totals.totalBrand = total_brand;            
      this.totals.totalMaizeQty = total_maizeqty;            
    }
  },

  watch: {
    ProductionCart(newValue) {
      if (newValue) {
        // this.updateTotals();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success"){
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    }
  },

  created() {
    this.FetchProductionBatches(this.data);
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-3">
                <download-excel
                  class="btn btn-info mt-4"
                  :data="ProductionBatches"
                  :fields="json_fields"
                  :worksheet="'PRODUCTION BATCHES FOR' + currentdate"
                  type="csv"
                  :name="'ProductionBatches_report from ' +data.datefrom+' to '+data.dateto+'.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ProductionBatches ? ProductionBatches : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_cost)="data">
                  {{ data.item.total_cost?(data.item.total_cost).toLocaleString():0 }}
                </template>
                <template #cell(total_brand)="data">
                  {{ data.item.total_brand?(data.item.total_brand).toLocaleString():0 }}
                </template>
                <template #cell(cost_price)="data">
                  {{ data.item.cost_price?(data.item.cost_price).toLocaleString():0 }}
                </template>
                <template #cell(total_labour)="data">
                  {{ data.item.total_labour?(data.item.total_labour).toLocaleString():0 }}
                </template>
                <template #cell(actions)="data">                      
                  <b-button-group>
                    <b-button variant="success" size="sm" @click="Viewdetails(data.item.id)">Details</b-button>
                    <b-button variant="primary" v-b-modal.edit-batch-modal @click="showEditModal(data)" size="sm"><i class="fa fa-pencil-alt"></i>Edit</b-button>
                    <b-button variant="danger" size="sm" v-b-modal.delete-batch-modal @click="showDeleteModal(data)"><i class="fa fa-trash"></i>Delete</b-button>
                  </b-button-group>
                </template>         
              </b-table>
              <div class="row">                
                <div class="col-md-4">
                  <h5>Total Cost: <span class="text-danger">{{(totals.totalAmount>0?totals.totalAmount.toLocaleString():0)}}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Maize Quantity: <span class="text-danger">{{(totals.totalMaizeQty>0?totals.totalMaizeQty.toLocaleString():0)}}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Brand: <span class="text-danger">{{(totals.totalBrand>0?totals.totalBrand.toLocaleString():0)}}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!ProductionBatches"/>

            <!-- Modals -->
            <!-- edit modal starts -->
            <b-modal
              header-bg-variant="warning"
              header-text-variant="light"
              body-text-variant="warning"
              footer-bg-variant="warning"
              footer-text-variant="warning"
              id="edit-batch-modal"
              hide-footer
              @hidden="resetEdit"
            >
              <template #modal-title> Edit This Batch</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Batch? Click Proceed Button to Return this Batch for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('edit-batch-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editBatch('edit-batch-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- edit modal ends -->

            <!-- delete modal begins -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-batch-modal"
              hide-footer
              @hidden="resetDelete"
            >
              <template #modal-title> Delete This Batch</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Batch? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-batch-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteBatch('delete-batch-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- delete modal ends -->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
